import {version} from "./../package.json";

export const API_MODES = {
  LOCAL: "LOCAL",
  LOCAL_ANDROID: "LOCAL_ANDROID",
  STAGING: "STAGING",
  LIVE: "LIVE",
  QE: "QE",
  TESTING: "TESTING",
};

let PRODUCT = null;
let PLATFORM = null;
let LOCATION_ID = null;
let DEVICE_TOKEN = null;
let ACCOUNT_TOKEN = null;
let APPLICATION_TOKEN = null;
let APPLICATION_VERSION = null;

let API_MODE = API_MODES.LOCAL;

/**
 * Sets up the frostbyte ticket system which includes settings headers
 *
 * @param params
 * @param params.location {Number}        The location ID of this specific shop
 * @param params.device {String}          The device unique id
 * @param params.account {String}         The account session token
 * @param params.application {String}     The application token
 * @param params.product {String}         The product
 * @param params.platform {String}        The platform
 *
 * @param params.mode {String}            The sdk mode
 */
export function setupFrostbyteTickets(params = {}) {
  let {
    location,
    device,
    account,
    application,
    mode,
    product,
    platform,
    version,
  } = params;

  if (location) {
    LOCATION_ID = location;
  }

  if (device) {
    DEVICE_TOKEN = device;
  }

  if (account) {
    ACCOUNT_TOKEN = account;
  }

  if (application) {
    APPLICATION_TOKEN = application;
  }

  if (mode) {
    API_MODE = mode;
  }

  if (product) {
    PRODUCT = product;
  }

  if (platform) {
    PLATFORM = platform;
  }

  if (version) {
    APPLICATION_VERSION = version;
  }

  console.log("Frostbyte Tickets has been setup with mode: " + API_MODE);
}

export function checkFrostbyteTicketConnection() {}

/**
 * Fetches the request headers for all frostbyte ticket calls
 */
export function fetchFrostbyteTicketHeaders() {
  let requestHeaders = {
    Source: "Frostbyte-Tickets Node.js v" + version,
  };

  if (LOCATION_ID !== null) {
    requestHeaders["Location"] = LOCATION_ID;
  }

  if (DEVICE_TOKEN) {
    requestHeaders["Device-Token"] = DEVICE_TOKEN;
  }

  if (ACCOUNT_TOKEN) {
    requestHeaders["Authentication"] = ACCOUNT_TOKEN;
  }

  if (APPLICATION_TOKEN) {
    requestHeaders["Application"] = APPLICATION_TOKEN;
  }

  if (APPLICATION_VERSION) {
    requestHeaders["Versioning"] = APPLICATION_VERSION;
  }

  return requestHeaders;
}

/**
 * Fetches which API Mode the sdk is in
 */
export function fetchApiMode() {
  return API_MODE;
}

export function fetchProduct() {
  return PRODUCT;
}

export function fetchPlatform() {
  return PLATFORM;
}
